/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BlocksImageDataFromJSON, BlocksImageDataToJSON, } from './BlocksImageData';
/**
 * Check if a given object implements the StrapiBlock interface.
 */
export function instanceOfStrapiBlock(value) {
    return true;
}
export function StrapiBlockFromJSON(json) {
    return StrapiBlockFromJSONTyped(json, false);
}
export function StrapiBlockFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'] == null ? undefined : json['type'],
        'children': json['children'] == null ? undefined : (json['children'].map(StrapiBlockFromJSON)),
        'text': json['text'] == null ? undefined : json['text'],
        'bold': json['bold'] == null ? undefined : json['bold'],
        'italic': json['italic'] == null ? undefined : json['italic'],
        'underline': json['underline'] == null ? undefined : json['underline'],
        'strikethrough': json['strikethrough'] == null ? undefined : json['strikethrough'],
        'code': json['code'] == null ? undefined : json['code'],
        'level': json['level'] == null ? undefined : json['level'],
        'format': json['format'] == null ? undefined : json['format'],
        'url': json['url'] == null ? undefined : json['url'],
        'image': json['image'] == null ? undefined : BlocksImageDataFromJSON(json['image']),
    };
}
export function StrapiBlockToJSON(json) {
    return StrapiBlockToJSONTyped(json, false);
}
export function StrapiBlockToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'children': value['children'] == null ? undefined : (value['children'].map(StrapiBlockToJSON)),
        'text': value['text'],
        'bold': value['bold'],
        'italic': value['italic'],
        'underline': value['underline'],
        'strikethrough': value['strikethrough'],
        'code': value['code'],
        'level': value['level'],
        'format': value['format'],
        'url': value['url'],
        'image': BlocksImageDataToJSON(value['image']),
    };
}
